<!--
 * @Author: Du Feng
 * @LastEditors: Du Feng
 * @Date: 2021-12-23 09:55:45
 * @LastEditTime: 2021-12-23 10:44:04
 * @Description: Modify here please
-->
<template>
  <div>
    <div class="detail" v-show="!detail.show">
      <div class="header">
        <div class="left" @click="goBack()">< 返回</div>
        <div class="span1">
          <span>
             查看机构从业人员
         </span
          >
        </div>
      </div>
      <div>
        <!-- =================== -->
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入从业人员"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.status"
              clearable
              placeholder="账号状态"
              class="label"
            >
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="account" label="账号" align="center">
            </el-table-column>
            <el-table-column prop="country" label="国籍" align="center">
            </el-table-column>
            <el-table-column
              prop="employ_method"
              label="聘用方式"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="source" label="来源" align="center">
            </el-table-column>
            <el-table-column
              prop="record"
              label="教育部备案状态"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="status" label="账号状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.status | statusFilter }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              fixed="right"
              width="120px"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看</el-button
                >
                <el-button type="text" size="small" @click="setStatus(scope.row.user_id)"
                  >锁定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="page.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pageSize"
              :total="page.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
        <!-- =================== -->
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import { getOrgQYList,setUserStatus } from "@/api/user/userCenter";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  props: ["orgId"],
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      queryParams: {
        status: "",
        name: "",
      },
      detail: {
        info: {},
        show: false,
      },
      tableData: [],
      statusList: [
        { id: "0", label: "未激活" },
        { id: "1", label: "正常" },
        { id: "2", label: "注销" },
        { id: "3", label: "锁定" },
        { id: "4", label: "安管锁定" },
        { id: "5", label: "空间封锁" },
      ],
    };
  },
  //   computed:{
  //     orgIdChange:function(){
  //       return this.orgId
  //     },
  //   },
  watch: {
    orgId: function (n, o) {
      // console.log('监听orgId-------',n);
      this.page.pageNum = 1;
      this.getDataList(n);
    },
  },
  created() {},
  mounted() {},
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    recordStatusFilter(type) {
      const typeMap = {
        0: "未备案",
        1: "已备案",
      };
      return typeMap[type];
    },
  },
  methods: {
    async getDataList(orgId) {
      let params = {
        top_org_id: orgId,
        org_id: "",
        org_recursion: "0",
        top_school_id: "",
        name: this.queryParams.name,
        page: this.page.pageNum,
        page_size: this.page.pageSize,
        status: this.queryParams.status, //用户状态(0:未激活, 1:正常, 2:注销, 3:锁定, 4:安管锁定,5空间封锁)，多个用”,”分割）
      };
      var { code, result } = await getOrgQYList(params);
      console.log("教育局获取get用户中心在职人员列表---",code,result);
      if (code == "000000") {
        this.tableData = result.member_list;
        this.page.totalPage = result.count;
      }
    },
    async setStatus(userId){
      let params = {
        usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
        user_id:userId,
        status:'3',//0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
      };
      var { code, message } = await setUserStatus(params);
      if (code == "000000") {
         this.page.pageNum=1
         this.getDataList(this.orgId);
         this.$message({
          type: "success",
          message: "操作成功",
        });
      }else{
        this.$message({
          type: "error",
          message: message,
        });
      }
    }, 
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList(this.orgId);
    },
    sizeChangeHandle(val) {
      this.page.pageSize = val;

      this.getDataList(this.orgId);
    },
    currentChangeHandle(val) {
      this.page.pageNum = val;
      this.getDataList(this.orgId);
    },
    toIndex() {
      this.detail.show = false;
      this.page.pageNum = 1;
      this.getDataList();
    },
    goBack() {
      this.$emit("to-index");
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .table {
    margin-top: 50px;
  }
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 30px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-left: 30%;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
